import { QueryConfig } from "store/utils/query-config";

export const LEDGERS_PAGE_SIZE = 500;

export const ledgersDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};

